import type { Contact } from "../types/contact.types";

// Supports the supplied PDF's brackets as well as the app's existing brace conventions.
const placeholderPattern = () =>
  /\[([A-Za-z][A-Za-z0-9_. ]*)\]|\{\{\s*([A-Za-z][A-Za-z0-9_. ]*?)\s*\}\}|\{([A-Za-z][A-Za-z0-9_. ]*)\}/g;
export function unresolvedSmsVariables(body: string): string[] {
  return [
    ...new Set(
      [...body.matchAll(placeholderPattern())].map((m) =>
        (m[1] ?? m[2] ?? m[3]).trim(),
      ),
    ),
  ];
}
function renewalDate(raw?: string): string | undefined {
  if (!raw) return undefined;
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(raw);
  if (!match) return undefined;
  const [, y, m, d] = match;
  const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)));
  if (
    date.getUTCFullYear() !== Number(y) ||
    date.getUTCMonth() !== Number(m) - 1 ||
    date.getUTCDate() !== Number(d)
  )
    return undefined;
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}
export function populateSmsTemplate(
  body: string,
  contact: Contact,
  agentName?: string,
): string {
  const products = [
    ...new Set(
      (contact.product_names ?? []).map((p) => p.trim()).filter(Boolean),
    ),
  ];
  const values: Record<string, string | undefined> = {
    firstname: contact.first_name?.trim(),
    agentname: agentName?.trim(),
    planname: products.length === 1 ? products[0] : undefined,
    renewaldate: renewalDate(contact.member_renewal_date),
  };
  return body.replace(placeholderPattern(), (whole, square, double, single) => {
    const key = String(square ?? double ?? single)
      .trim()
      .replace(/^contact\./i, "")
      .replace(/[ _]/g, "")
      .toLowerCase();
    return values[key] || whole;
  });
}
/** Optional draft-only conversion: never rewrites the stored wording. */
export function smsFriendlyCharacters(body: string): string {
  return body
    .replace(/®/g, "(R)")
    .replace(/[‘’]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[–—]/g, "-")
    .replace(/\u00a0/g, " ");
}
